import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../Template/Button'

export interface ISaveDatesButtonProps {
  isDisabled: boolean
  buttonText?: ReactNode
  onClick?: () => void
}

const SaveDatesButton = ({
                           isDisabled,
                           buttonText,
                           onClick,
                         }: ISaveDatesButtonProps) => {
  const [t] = useTranslation()

  const handleClick = () => onClick && onClick()

  return (
    <Button
      style={{ width: '100%' }}
      onClick={handleClick}
      primary={true}
      isDisabled={isDisabled}
    >
      {buttonText || t('BBO_1438_confirm_date')}
    </Button>
  )
}

export default SaveDatesButton
